import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import Home from './pages/Home';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Services from './pages/Services';
import Booking from './pages/Booking';
import Contact from './pages/Contact';
import About from './pages/About';
import Support from './pages/Support';

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-gray-50 dark:bg-gray-900">
        <Helmet>
          <title>TeachWithDuke - Personalized Programming Education</title>
          <meta name="description" content="Learn Python, React, DevOps, Machine Learning, and Data Analysis with personalized 1-on-1 mentorship from Duke. Global online teaching platform." />
          <meta name="keywords" content="programming, python, react, devops, machine learning, data analysis, online teaching, mentorship, coding bootcamp" />
          <meta property="og:title" content="TeachWithDuke - Personalized Programming Education" />
          <meta property="og:description" content="Learn programming with personalized 1-on-1 mentorship. Available worldwide." />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="TeachWithDuke - Personalized Programming Education" />
          <meta name="twitter:description" content="Learn programming with personalized 1-on-1 mentorship. Available worldwide." />
        </Helmet>
        
        <Navbar />
        
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:slug" element={<CourseDetail />} />
            <Route path="/services" element={<Services />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </main>
        
        <Footer />
        <FloatingWhatsApp />
      </div>
    </Router>
  );
}

export default App;
